/* global debounce */

if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.js-search-input');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = document.getElementById('product_type_input');
      this.resetBtn = this.querySelector('.js-search-reset');

      // bind once
      this._onInput = this.handleInput.bind(this);
      this._onProductTypeChange = this.handleProductTypeChange.bind(this);
      this._onReset = this.handleReset.bind(this);
    }

    connectedCallback() {
      // Immediate, synchronous visual feedback
      this.input.addEventListener('input', this._onInput);

      // If you have an async search, keep it separate and debounced
      if (typeof debounce === 'function' && typeof this.handleSearch === 'function') {
        const debounced = debounce(() => this.handleSearch(), 250);
        this.input.addEventListener('input', debounced);
      }

      if (this.productTypeSelect) {
        this.productTypeSelect.addEventListener('change', this._onProductTypeChange);
      }
      if (this.resetBtn) {
        this.resetBtn.addEventListener('click', this._onReset);
      }
    }

    disconnectedCallback() {
      // Let GC clean up; listeners are bound to this instance
      this.input?.removeEventListener('input', this._onInput);
      if (typeof this.handleSearch === 'function') {
        // no-op: debounced handler was inline; page reloads will recreate it
      }
      this.productTypeSelect?.removeEventListener('change', this._onProductTypeChange);
      this.resetBtn?.removeEventListener('click', this._onReset);
    }

    // Instant visual reaction
    handleInput() {
      const el = this.input;
      el.classList.toggle('search__input--dirty', el.value.length > 0);
    }

    // Works with native <select> and custom events with detail.selectedValue
    handleProductTypeChange(evt) {
      const next = evt?.detail?.selectedValue ?? evt?.target?.value;
      if (next != null && this.productTypeInput) {
        this.productTypeInput.value = next;
      }
    }

    handleReset() {
      this.input.classList.remove('search__input--dirty');
    }
  }

  customElements.define('search-form', SearchForm);
}